export default __webpack_public_path__ + "static/media/Vest of the Blood God (nm).9104e133.jpg";